import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ordersService {

  constructor(private api : ApiService,private http: HttpClient) { }

  getOrders(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/job/getJobs?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
  } 
  getFtlOrders(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}ptl-service/order/getOrderInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  } 
  getPtlOrders(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}ptl-service/pickupRequest/getPickupRequestAndIntimationInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  } 

  getDraftJobs(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/job/getDraftJobs?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 

addOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ftl-service/job/addOrUpdate')
  return this.api.post(url,formData);
}
draftAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ftl-service/job/draftAddOrUpdate')
  return this.api.post(url,formData);
}
bulkAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ems-service/budget/bulkAddOrUpdate')
  return this.api.post(url,formData);
}
getRoleMappingList(){
  const url = `${environment.New_BASE_DOMAIN}auth-service/role/getRoleMappingList`;
  return this.api.get(url);
} 

getBudgetTransactions(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ems-service/budget/getBudgetTransactions?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=updatedAt&direction=DESC`;
  return this.api.post(url,formData);
}
getLineItemTransactions(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/job/getLineItemTransactions?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=updatedAt&direction=ASC`;
  return this.api.post(url,formData);
}

updateLineItems(payload:any){
  const url = (environment.New_BASE_DOMAIN + 'ftl-service/job/addOrUpdate')
  return this.api.post(url,payload);
}
getAssociateList(payload:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/user/getUsers?pageNumber=${pageNumber}&pageSize=${pageSize}&direction=ASC`;
  return this.api.post(url,payload);
}


getLocations(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/location/getLocations?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
getVehicleType(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/vehicle/getVehicleType?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
} 
getMaterialType(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/vehicle/getMaterialType?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 
getRoutes(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ftl-service/route/getRoutes?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
getAccounts(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}ftl-service/account/getAccountInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  }

  getNotificationLogs(payload: any) {
    const url = `https://ems-dev.apollosupplychain.com/comms-service/notification/getNotificationLogs?pageNumber=0&pageSize=10000`;
    const headers = new HttpHeaders({
      'AuthUrl': `${environment.New_BASE_DOMAIN}/ftl-auth-service/validate/user`,
    });
  
    return this.http.post(url, payload, { headers });
  }

getOrderById(orderId:any){
  const url = `${environment.New_BASE_DOMAIN}ptl-service/order/getById?orderId=${orderId}`;
  return this.api.get(url);
}
getOrderTripById(orderId:any){
  const url = `${environment.New_BASE_DOMAIN}ptl-service/trip/getByOrderId?OrderId=${orderId}`;
  return this.api.get(url);
}

createUpdateOrder(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ptl-service/order/addOrUpdate')
  return this.api.post(url,formData);
}
createUpdateOrderBidding(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'bidding-service/order/addOrUpdate')
  return this.api.post(url,formData);
}
getVendorInfo(formData:any,pageNumber:any,pageSize:any){
  const url = (environment.New_BASE_DOMAIN + `account-service/vendor/getVendorInfo?pageNumber=${pageNumber}&pageSize=${pageSize}`)
  return this.api.post(url,formData);
}
getVendorOrders(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}bidding-service/order/getOrders?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
getTripInfo(formData:any,pageNumber:any = 0,pageSize:any = 100,sortingCol:any = 'id', direction:any = 'ASC'){
  const url = `${environment.New_BASE_DOMAIN}ptl-service/trip/getTripInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
getClaimsForVendorBilling(formData:any,pageNumber:any = 0,pageSize:any = 100,sortingCol:any = 'id', direction:any = 'ASC'){
  const url = `${environment.New_BASE_DOMAIN}claim-service/claim/getClaims?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
saveVendorBilling(formData:any){
  const url = `${environment.New_BASE_DOMAIN}claim-service/vendorBilling/addOrUpdate`;
  return this.api.post(url,formData);
}
saveCustomerBilling(formData:any){
  const url = `${environment.New_BASE_DOMAIN}claim-service/customerBilling/addOrUpdate`;
  return this.api.post(url,formData);
}
tripGenration(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ptl-service/trip/addOrUpdate')
  return this.api.post(url,formData);
}
getGstList(accountId:any){
  const url = `${environment.New_BASE_DOMAIN}account-service/account/gst/getByAccountId?accountId=${accountId}`;
  return this.api.get(url);
}
saveEwayBill(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'pod-service/ewaybill/addOrUpdate')
  return this.api.post(url,formData);
}
fetchEwayBill(ewayBillNumber:any,gstNumber:any){
  const url = `${environment.New_BASE_DOMAIN}integration-service/ewaybill/getEwayBillDetail?ewayBillNo=${ewayBillNumber}&gstNo=${gstNumber}`;
  return this.api.get(url);
}
saveTrip(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ptl-service/trip/addOrUpdate')
  return this.api.post(url,formData);
}
saveAllLr(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ptl-service/trip/lr/addOrUpdate')
  return this.api.post(url,formData);
}
getEwayBillList(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}pod-service/ewaybill/getEwayBills?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
getAllMasterCategory() {
  const url = `${environment.BASE_DOMAIN}ptl-service/master/getAllMasterCategory`;
  return this.api.get(url);
}
getQuickCodeListByCategoryId(ids: any) {
  let url = `${environment.New_BASE_DOMAIN}ptl-service/master/getQuickCodeListByCategoryId`
  if (ids) {
    url += `?categoryId=${ids}`;
  }
  return this.api.get(url);
}
getLrInfoList(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ptl-service/trip/getLrInfo?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
getAdditionalCharges(formData:any,pageNumber:any,pageSize:any,sortingCol:any = 'id', direction:any = 'ASC'){
  const url = `${environment.New_BASE_DOMAIN}pod-service/additionalCharges/getAdditionalCharges?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
getPods(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}pod-service/pod/getPods?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
savePod(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'pod-service/pod/addOrUpdate')
  return this.api.post(url,formData);
}
saveAdditionalCharge(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'pod-service/additionalCharges/addOrUpdate')
  return this.api.post(url,formData);
}
getConfigurations(formData: any[] = [], pageNumber: any = 0, pageSize: any = 10) {
  const url = `${environment.New_BASE_DOMAIN}account-service/configuration/getConfigurations?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url, formData);
}

saveConfiguration(formData: any) {
  const url = `${environment.New_BASE_DOMAIN}account-service/configuration/addOrUpdate`;
  return this.api.post(url, formData);
}
getBiddingTransactions(formData:any,pageNumber:any,pageSize:any,sortingCol:any = 'id', direction:any = 'ASC'){
  const url = `${environment.New_BASE_DOMAIN}bidding-service/order/getBiddingTransactions?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

uploadFilesURL(){
  const url = `${environment.New_BASE_DOMAIN}utils-service/uploads/uploadFiles`;
  return url;
}
fetchTracking(formData: any) {
  const url = `${environment.New_BASE_DOMAIN}tracking-service/freightTiger/addOrUpdate`;
  return this.api.post(url, formData);
}
generateLrNumber() {
  const url = `${environment.New_BASE_DOMAIN}ptl-service/lr-number/generate`;
  return this.http.get(url);
}
getHistoricalRate(sourceId:any,destinationId:any,accountId:any){
  const url = `${environment.BASE_DOMAIN}ptl-service/order/price-history/average?sourceId=${sourceId}&destinationId=${destinationId}&accountId=${accountId}`;
  return this.api.get(url);
}
getByAccountId(accountId:any){
  const url = `${environment.BASE_DOMAIN}account-service/account/gst/getByAccountId?accountId=${accountId}`;
  return this.api.get(url);
}
getCustomerAddress(formData: any) {
  const url = `${environment.New_BASE_DOMAIN}account-service/customer/getCustomerAddress?pageNumber=0&pageSize=100000`;
  return this.api.post(url, formData);
}
submitMultiPod(formData:any){
  const url = `${environment.New_BASE_DOMAIN}pod-service/pod/bulkAddOrUpdate`;
  return this.api.post(url, formData);
}

getAppointmentInfo(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}ptl-service/appointment/getAppointmentInfo?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
addOrUpdateAppointment(formData:any){
  const url = `${environment.New_BASE_DOMAIN}ptl-service/appointment/addOrUpdate`;
  return this.api.post(url,formData);
}
bulkAddOrUpdateAppointment(formData:any){
  const url = `${environment.New_BASE_DOMAIN}ptl-service/appointment/bulkAdd`;
  return this.api.post(url,formData);
}
getTrackingDetail(carrier:any, trackingId:any){
  const url = `${environment.New_BASE_DOMAIN}integration-service/carrier/getTrackingDetail?carrier=${encodeURIComponent(carrier)}&trackingId=${encodeURIComponent(trackingId)}`;
  return this.api.get(url);
}
}
